import { snakeCase } from 'scule';
export const HEADER_X_AW_PERF_UUID = 'x-aw-perf-uuid';
export const trackedPEnvKeys = new Set();
export const capitalizeFirstLetter = (value) => {
    return value.charAt(0).toUpperCase() + value.slice(1);
};
export const envIsBoolean = (val) => (val !== undefined) && ['1', 'true'].includes(val);
export const pEnv = createPEnv(process.env, true);
export function createPEnv(envsRecord, isTrackingEnabled) {
    return new Proxy(envsRecord, {
        get(envs, key, receiver) {
            if (isTrackingEnabled) {
                trackedPEnvKeys.add(key);
            }
            const value = Reflect.get(envs, key, receiver);
            if (value === undefined) {
                throw new Error(`${String(key)} doesnt exist inside envs.`);
            }
            return value;
        },
    });
}
/**
  * `scule` is used internally by nuxt for snakecasing, it is tricky
  * because auchanCPU is AUCHAN_CPU and not AUCHAN_C_P_U .
*/
export function configToEnvFormatter(value) {
    return snakeCase(value).toUpperCase();
}
//# sourceMappingURL=anyPlatform.js.map